import { render, staticRenderFns } from "./ExpandButton.vue?vue&type=template&id=0b44a10c&scoped=true&"
import script from "./ExpandButton.vue?vue&type=script&lang=js&"
export * from "./ExpandButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpandButton.vue?vue&type=style&index=0&id=0b44a10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b44a10c",
  null
  
)

export default component.exports